/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Checkbox, Icon } from "@material-ui/core";

import "./MultiPulldown.scss";

const MultiSelect = ({
  items, selectedValues, label, placeholder, selectAllLabel, noOptionsText, limitTags, onToggleOption, onClearOptions, onSelectAll, getOptionLabel }) => {
  const allSelected = items?.length === selectedValues?.length;
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find(option => option.id === "全て")) {
        console.log('すべて')
        handleToggleSelectAll();
      } else {
        onToggleOption && onToggleOption(selectedOptions);
      }
    } else if (reason === "clear") {
      onClearOptions && onClearOptions();
    }
  };
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.id === "全て" // To control the state of '全て' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          // color="primary"
          icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 16 }} className="multiCheck" />}
          checkedIcon={<CheckBoxIcon style={{ fontSize: 16 }} />}
          style={{ marginLeft: -15, marginRight: -2, color: '#ffffff', height: 15 }}// ☑ 色
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const inputRenderer = params => (
    <TextField {...params} placeholder={placeholder} label={label} />
  );
  const getOptionSelected = (option, anotherOption) =>
    option.id === anotherOption.id;
  const filter = createFilterOptions();

  return (
    <Autocomplete
      style={{ maxHeight: 150, backgroundColor: 'white', }}//width追加可能
      popupIcon={<Icon style={{ marginTop: -5, fontSize: '1.7rem', paddingTop: 5, color: '#000000' }}>expand_more</Icon>}
      className="MultiSelect"
      multiple
      options={items}
      value={selectedValues}
      disableCloseOnSelect //選択中に毎回閉じない
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        return [{ id: selectAllLabel, name: "全て" }, ...filtered];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  );
};

MultiSelect.defaultProps = {
  items: [],
  selectedValues: [],
  getOptionLabel: value => value
};

export default MultiSelect;
